console.log('Consert flip script loaded');

function initFlipContainers() {
    console.log('Initializing flip containers...');
    var containers = document.querySelectorAll('.consert-flip-container');
    console.log('Found', containers.length, 'flip containers');
    
    containers.forEach(function(container) {
        if (container.dataset.initialized === 'true') {
            return; // 既に初期化済み
        }
        
        container.dataset.initialized = 'true';
        
        // 両方の画像の高さを取得して、高い方の高さをコンテナに設定
        var frontImg = container.querySelector('.consert-flip-front img');
        var backImg = container.querySelector('.consert-flip-back img');
        
        if (frontImg && backImg) {
            var maxHeight = 0;
            var imagesLoaded = 0;
            
            function setContainerHeight() {
                // 両方の画像が読み込まれたら、高い方の高さを設定
                var frontHeight = frontImg.offsetHeight || frontImg.naturalHeight || frontImg.height;
                var backHeight = backImg.offsetHeight || backImg.naturalHeight || backImg.height;
                maxHeight = Math.max(frontHeight, backHeight);
                
                if (maxHeight > 0) {
                    // インラインスタイルを削除して、CSSのautoに任せる
                    container.style.height = '';
                    var flipInner = container.querySelector('.consert-flip-inner');
                    if (flipInner) {
                        flipInner.style.height = '';
                    }
                    // 背面の画像の高さを前面の画像に合わせる
                    var flipBack = container.querySelector('.consert-flip-back');
                    if (flipBack) {
                        flipBack.style.height = frontHeight + 'px';
                    }
                    console.log('Flip container height set to auto, front:', frontHeight, 'back:', backHeight);
                }
            }
            
            function checkHeight() {
                imagesLoaded++;
                if (imagesLoaded === 2) {
                    // 少し遅延させてから高さを設定（レンダリング完了を待つ）
                    setTimeout(setContainerHeight, 50);
                }
            }
            
            // 画像が既に読み込まれている場合
            if (frontImg.complete && backImg.complete && frontImg.naturalHeight > 0 && backImg.naturalHeight > 0) {
                setTimeout(setContainerHeight, 100);
            } else {
                // 画像の読み込みを待つ
                frontImg.addEventListener('load', checkHeight);
                backImg.addEventListener('load', checkHeight);
                // エラー時も処理を続行（画像が読み込めない場合でも高さを設定）
                frontImg.addEventListener('error', checkHeight);
                backImg.addEventListener('error', checkHeight);
            }
        } else if (frontImg || backImg) {
            // 1枚の画像のみの場合
            var singleImg = frontImg || backImg;
            function setSingleImageHeight() {
                // 1枚の画像の場合もインラインスタイルを削除して、CSSのautoに任せる
                container.style.height = '';
                var flipInner = container.querySelector('.consert-flip-inner');
                if (flipInner) {
                    flipInner.style.height = '';
                }
                console.log('Single image container height set to auto');
            }
            
            if (singleImg.complete && singleImg.naturalHeight > 0) {
                setTimeout(setSingleImageHeight, 100);
            } else {
                singleImg.addEventListener('load', function() {
                    setTimeout(setSingleImageHeight, 50);
                });
                singleImg.addEventListener('error', function() {
                    setTimeout(setSingleImageHeight, 50);
                });
            }
        }
        
        container.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            console.log('Flip container clicked');
            this.classList.toggle('flipped');
        });
        console.log('Flip container initialized');
    });
}

// 即座に実行
setTimeout(function() {
    initFlipContainers();
}, 100);

// DOMContentLoadedでも実行
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
        setTimeout(initFlipContainers, 100);
    });
}

// Turbolinks対応
document.addEventListener('turbolinks:load', function() {
    setTimeout(initFlipContainers, 100);
});

// window.loadでも実行
window.addEventListener('load', function() {
    setTimeout(initFlipContainers, 100);
});

// jQueryが利用可能な場合も対応
if (typeof jQuery !== 'undefined') {
    jQuery(document).on('turbolinks:load', function() {
        setTimeout(initFlipContainers, 100);
    });
    jQuery(document).ready(function() {
        setTimeout(initFlipContainers, 100);
    });
}
